/**
 * CoLab Contact Form Module
 * Валідація форми з real-time feedback та AJAX-відправкою
 */

export const Form = {
    form: null,
    fields: {},
    submitBtn: null,
    submitBtnText: null,
    serverErrorContainer: null,
    trans: {},
    // hCaptcha (optional: rendered only when enabled in .env)
    captcha: null,
    captchaError: null,

    init: function() {
        var self = this;

        this.form = document.getElementById('contact-form');
        if (!this.form) return;

        this.submitBtn = this.form.querySelector('[type="submit"]');
        this.submitBtnText = this.submitBtn.querySelector('span');
        this.serverErrorContainer = document.getElementById('form-server-error');
        this.trans = window.contactTranslations || {};

        this.captcha = this.form.querySelector('.h-captcha');
        this.captchaError = this.form.querySelector('[data-error="h-captcha-response"]');

        // Callbacks referenced by data-callback / data-expired-callback on the widget
        window.contactCaptchaSolved = function() { self.hideCaptchaError(); };
        window.contactCaptchaExpired = function() { self.showCaptchaError(self.trans.error_captcha_required); };

        this.setupFields();
        this.bindEvents();
    },

    captchaToken: function() {
        var field = this.form.querySelector('[name="h-captcha-response"]');
        return field ? field.value : '';
    },

    validateCaptcha: function() {
        if (!this.captcha) return true;

        if (!this.captchaToken()) {
            this.showCaptchaError(this.trans.error_captcha_required);
            return false;
        }

        this.hideCaptchaError();
        return true;
    },

    showCaptchaError: function(message) {
        if (!this.captchaError) return;
        this.captchaError.textContent = message || this.trans.error_captcha_required || '';
        this.captchaError.classList.remove('d-none');
    },

    hideCaptchaError: function() {
        if (!this.captchaError) return;
        this.captchaError.textContent = '';
        this.captchaError.classList.add('d-none');
    },

    // A token is single-use: reset the widget after every server round-trip
    resetCaptcha: function() {
        if (!this.captcha || !window.hcaptcha) return;
        try { window.hcaptcha.reset(); } catch (e) { /* widget not rendered yet */ }
    },

    setupFields: function() {
        var self = this;

        this.fields = {
            name: {
                element: this.form.querySelector('[name="name"]'),
                errorElement: this.form.querySelector('[data-error="name"]'),
                validate: function(value) {
                    if (!value.trim()) return self.trans.error_name_required;
                    if (value.trim().length < 2) return self.trans.error_name_min;
                    return null;
                }
            },
            email: {
                element: this.form.querySelector('[name="email"]'),
                errorElement: this.form.querySelector('[data-error="email"]'),
                validate: function(value) {
                    if (!value.trim()) return self.trans.error_email_required;
                    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(value)) return self.trans.error_email_invalid;
                    return null;
                }
            },
            phone: {
                element: this.form.querySelector('[name="phone"]'),
                errorElement: this.form.querySelector('[data-error="phone"]'),
                validate: function(value) {
                    if (!value.trim()) return self.trans.error_phone_required;
                    var phoneRegex = /^[\d\s\-\+\(\)]{7,}$/;
                    if (!phoneRegex.test(value)) return self.trans.error_phone_invalid;
                    return null;
                }
            },
            message: {
                element: this.form.querySelector('[name="message"]'),
                errorElement: this.form.querySelector('[data-error="message"]'),
                validate: function(value) {
                    if (!value.trim()) return self.trans.error_message_required;
                    if (value.trim().length < 15) return self.trans.error_message_min;
                    return null;
                }
            },
            agree: {
                element: this.form.querySelector('[name="agree"]'),
                errorElement: this.form.querySelector('[data-error="agree"]'),
                validate: function(value) {
                    var checkbox = self.form.querySelector('[name="agree"]');
                    if (!checkbox.checked) return self.trans.error_agree_required;
                    return null;
                }
            }
        };
    },

    bindEvents: function() {
        var self = this;

        // Real-time validation
        Object.keys(this.fields).forEach(function(name) {
            var field = self.fields[name].element;
            if (!field) return;

            field.addEventListener('blur', function() {
                self.validateField(name);
            });

            field.addEventListener('input', function() {
                if (field.classList.contains('is-invalid')) {
                    self.validateField(name);
                }
            });
        });

        // Form submit
        this.form.addEventListener('submit', function(e) {
            e.preventDefault();
            self.handleSubmit();
        });
    },

    validateField: function(name) {
        var fieldConfig = this.fields[name];
        if (!fieldConfig || !fieldConfig.element) return true;

        var error = fieldConfig.validate(fieldConfig.element.value);

        if (error) {
            this.showError(fieldConfig.element, fieldConfig.errorElement, error);
            return false;
        } else {
            this.showSuccess(fieldConfig.element, fieldConfig.errorElement);
            return true;
        }
    },

    validateForm: function() {
        var self = this;
        var isValid = true;

        Object.keys(this.fields).forEach(function(name) {
            if (!self.validateField(name)) {
                isValid = false;
            }
        });

        return isValid;
    },

    showError: function(field, errorElement, message) {
        field.classList.add('is-invalid');
        field.classList.remove('is-valid');

        if (errorElement) {
            errorElement.textContent = message;
            errorElement.classList.remove('d-none');
        }
    },

    showSuccess: function(field, errorElement) {
        field.classList.remove('is-invalid');
        field.classList.add('is-valid');

        if (errorElement) {
            errorElement.textContent = '';
            errorElement.classList.add('d-none');
        }
    },

    clearValidation: function(field, errorElement) {
        field.classList.remove('is-invalid', 'is-valid');

        if (errorElement) {
            errorElement.textContent = '';
            errorElement.classList.add('d-none');
        }
    },

    showServerError: function(message) {
        if (!this.serverErrorContainer) return;

        var errorMessage = this.serverErrorContainer.querySelector('#form-server-error-message');
        if (errorMessage) {
            errorMessage.textContent = message;
        }

        this.serverErrorContainer.classList.remove('d-none');

        // Scroll to error
        this.serverErrorContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },

    hideServerError: function() {
        if (!this.serverErrorContainer) return;
        this.serverErrorContainer.classList.add('d-none');
    },

    handleSubmit: function() {
        var self = this;

        // Hide previous server errors
        this.hideServerError();

        // Validate form
        if (!this.validateForm()) {
            var firstInvalid = this.form.querySelector('.is-invalid');
            if (firstInvalid) {
                firstInvalid.focus();
            }
            return;
        }

        // Captcha must be solved before we hit the server
        if (!this.validateCaptcha()) {
            this.captcha.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
        }

        // Collect form data
        var formData = new FormData(this.form);

        // Loading state
        this.setLoading(true);

        // AJAX submission
        fetch(this.form.action, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            }
        })
            .then(function(response) {
                return response.json().then(function(data) {
                    return { status: response.status, data: data };
                });
            })
            .then(function(result) {
                self.setLoading(false);
                self.resetCaptcha();

                if (result.status === 200 || result.status === 201) {
                    // Success
                    self.showSuccessMessage();
                    self.form.reset();

                    // Clear validation states
                    Object.keys(self.fields).forEach(function(name) {
                        if (self.fields[name].element && self.fields[name].errorElement) {
                            self.clearValidation(self.fields[name].element, self.fields[name].errorElement);
                        }
                    });
                } else if (result.status === 422) {
                    // Validation errors
                    self.handleValidationErrors(result.data.errors);
                } else {
                    // Other errors
                    self.showServerError(result.data.message || self.trans.error_general);
                }
            })
            .catch(function(error) {
                self.setLoading(false);
                self.resetCaptcha();
                console.error('Form submission error:', error);
                self.showServerError(self.trans.error_general);
            });
    },

    handleValidationErrors: function(errors) {
        var self = this;
        errors = errors || {};

        if (errors['h-captcha-response']) {
            this.showCaptchaError(errors['h-captcha-response'][0]);
        }

        Object.keys(errors).forEach(function(fieldName) {
            if (self.fields[fieldName]) {
                var errorMessage = errors[fieldName][0];
                self.showError(
                    self.fields[fieldName].element,
                    self.fields[fieldName].errorElement,
                    errorMessage
                );
            }
        });

        // Focus first invalid field
        var firstInvalid = this.form.querySelector('.is-invalid');
        if (firstInvalid) {
            firstInvalid.focus();
        }
    },

    setLoading: function(loading) {
        if (!this.submitBtn || !this.submitBtnText) return;

        if (loading) {
            this.submitBtn.disabled = true;
            this.submitBtn.classList.add('is-loading');
            this.submitBtnText.textContent = this.trans.button_sending || 'Надсилання...';
        } else {
            this.submitBtn.disabled = false;
            this.submitBtn.classList.remove('is-loading');
            this.submitBtnText.textContent = this.trans.button_submit || 'Надіслати';
        }
    },

    showSuccessMessage: function() {
        var self = this;
        var successMessage = document.createElement('div');
        successMessage.className = 'form-success-message';
        successMessage.innerHTML = '\
            <div class="form-success-message__icon">\
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">\
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>\
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>\
                </svg>\
            </div>\
            <h4 class="heading">' + this.trans.success_title + '</h4>\
            <p>' + this.trans.success_message + '</p>\
        ';

        this.form.parentNode.insertBefore(successMessage, this.form);
        this.form.style.display = 'none';

        setTimeout(function() {
            successMessage.remove();
            self.form.style.display = '';
        }, 5000);
    }
};
